<!-- static content data from lang: patient_list -->
<template>
  <div class="container">
    <div class="my-3" v-loading="loading">
      <b-card class="patient-listing">
        <div class="row">
          <template v-if="errored"> {{ lang.label.error }}</template>
          <template v-else>
            <template v-if="data.length > 0">        
                <div
                  class="col-md-6 col-lg-4"
                  v-for="(patient, index) in data"
                  :key="index"
                >
                  <a
                    href="javascript:void(0)"
                    @click="groupRequestDetails(patient)"
                  >
                    <b-card class="shadow-none" :class="{ 'glp-card': patient.isGlp }" body-class="p-3">
                      <span v-if="patient.isGlp" class="glp-badge">{{ lang.label.glp }}</span>
                      <div class="row">
                        <div
                          class="col-12 col-lg-12 align-items-right"
                          v-if="patient.status == 0"
                        >
                          <span class="noti-text">New</span>
                        </div>
                        <div class="col-6 col-lg-5">
                          <span class="mb-2 d-block"
                            >{{ lang.label.name }}:</span
                          >
                        </div>
                        <div class="col-6 col-lg-7">
                          <span class="mb-2 d-block">{{
                            patient.patientName != ""
                              ? patient.patientName
                              : lang.label.nodata
                          }}</span>
                        </div>
                        <div class="col-6 col-lg-5">
                          <span class="mb-2 d-block"
                            >{{ lang.label.phoneNumber }}:</span
                          >
                        </div>
                        <div class="col-6 col-lg-7">
                          <span class="mb-2 d-block">{{
                            patient.mobile != ""
                              ? patient.mobile
                              : lang.label.nodata
                          }}</span>
                        </div>
                        <div class="col-6 col-lg-5">
                          <span class="mb-2 d-block"
                            >{{ lang.label.emailId }}:</span
                          >
                        </div>
                        <div class="col-6 col-lg-7">
                          <span class="mb-2 d-block">{{
                            patient.email != ""
                              ? patient.email
                              : lang.label.nodata
                          }}</span>
                        </div>
                        <div class="col-6 col-lg-5">
                          <span class="mb-2 d-block"
                            >{{ lang.label.date }}:</span
                          >
                        </div>
                        <div class="col-6 col-lg-7">
                          <span class="mb-2 d-block">{{
                            formatDate(patient.createdAt)
                          }}</span>
                        </div>
                      </div>
                    </b-card>
                  </a>
                </div>
            </template>
            <template v-else>
              <div class="col-12 text-center pt-3">
                {{ lang.label.noDataFound }}
              </div>
            </template>
          </template>
        </div>
      </b-card>
    </div>
   <div v-observe-visibility="visibilityChanged">
   </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

var moment = require("moment"); // require
export default {
  components: {},
  data() {
    return {
      data: [],
      lang: this.$lang.group_request_list,
      loading: true,
      errored: false,
      finished: false,
      currentPage: 1,
      nursenote:[],
      allLoaded:false,
    };
  },
  mounted() {
    this.groupRequestList();
    // window.addEventListener('scroll', this.onLoad);
    // window.addEventListener('scroll', this.scroll);
  },
  destroyed () {
    // window.removeEventListener('scroll', this.scroll);
  },
  methods: {
    visibilityChanged(){
      if(!this.allLoaded){
       this.groupRequestList();
      }
    },
    groupRequestList(flag) {
      let self = this;
      this.loading = true;
      let data = {
        pageNo: self.currentPage,
        // "status":1
      };
      // let data = {};
      this.$store
        .dispatch("getGroupRequestList", data)
        .then((response) => {
          if (response.length > 0) {
            this.data = this.data.concat(response);
            // pushing unique datas
            let uniqueIds = new Set();
            let unique = this.data.filter(element => {
              let isDuplicate = uniqueIds.has(element.formsManagementId);
              uniqueIds.add(element.formsManagementId);

              if (!isDuplicate) {
                return true;
              }
              return false;
            });
            this.data=unique;

            this.currentPage = this.currentPage + 1;
            // console.log('res', response);
            
            // console.log('data', this.data);
          } else {
            self.allLoaded = true;
          }
          if (flag) {
            self.$alert(this.lang.label.successfullyAssigned, "", {
              confirmButtonText: "OK",
            });
            self.$router.push({ name: "group-request-details" });
          }
          // this.finished=true;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    formatAddress(address) {
      return address.replace(/\n/g, "<br/>");
    },
    formatDob(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    groupRequestDetails(data) {
      let self = this;
      if (data.status == 0) {
        this.$swal
          .fire({
            title: "",
            text: "You have a new script request",
            type: "",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ACCEPT",
            cancelButtonText: "CANCEL",
            allowOutsideClick: false,
          })
          .then((result) => {
            this.loading = true;
            if (result.value) {
              // old
              // let formData = {
              //   groupRequestId: data.groupRequestId,
              // };
                let formData = {
                formsManagementId: data.formsManagementId,
              };
              self.$store.dispatch("assignToDoctor", formData).then((value) => {
                this.loading = false;
                if (value.status == 200) {
                  self.$store.commit("setGroupRequestDetails", data);
                  self.groupRequestList(true);
                } else {
                  this.loading = false;
                  self.$swal
                    .fire({
                      title: "Request already accepted",
                      text: "This request has been accepted by another doctor",
                      type: "error",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "OK",
                    })
                    .then((result) => {});
                }
              });
            }
            this.loading = false;
          });
        return;
      }
      // return;
      this.$store.commit("setGroupRequestDetails", data);
      this.$router.push({ name: "group-request-details" });
    },
    formatGender(value) {
      if (value === 1) {
        return this.lang.label.male;
      } else if (value === 2) {
        return this.lang.label.female;
      } else if (value === 3) {
        return this.lang.label.other;
      } else {
        return this.lang.label.nodata;
      }
    },
  },
};
</script>
